import React from 'react';
import {
  Box,
  Divider,
} from '@mui/material';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { OptimizationSelector } from './api/OptimizationSelector';
import { OptimizationButtons } from './api/OptimizationButtons';
import { OptimizationStatus } from './api/OptimizationStatus';
import { OptimizationDownload } from './OptimizationDownload';
import { TrialSelector } from 'features/lime/components/TrialSelector';
import { LIMEResultViewer } from 'features/lime/components/LIMEResultViewer';
import { TrialApiButtons } from './api/TrialApiButtons';

const subtitleSx = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
};

const sectionTitleSx = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  marginTop: 1
};

export const OptimizationAPIs: React.FC = () => {
  return (
    <Box component="div" sx={{ height: '100%', boxSizing: 'border-box', padding: 0.5, gap: 0.5 }}>

      <Box component="div" sx={subtitleSx}>
        <CustomTypography>Optimization APIs</CustomTypography>
      </Box>

      <Divider sx={{ width: '100%', my: 0.5, bgcolor: '#e1e1e1' }} />

      <OptimizationButtons />
      <OptimizationSelector />
      <OptimizationDownload />
      <OptimizationStatus />

      <Box component="div" sx={sectionTitleSx}>
        <CustomTypography>Trial details</CustomTypography>
      </Box>
      <Divider sx={{ width: '100%', my: 0.5, bgcolor: '#e1e1e1' }} />

      <TrialSelector />

      <Box component="div" sx={sectionTitleSx}>
        <CustomTypography>Trial APIs</CustomTypography>
      </Box>
      <Divider sx={{ width: '100%', my: 0.5, bgcolor: '#e1e1e1' }} />

      <TrialApiButtons />
      <LIMEResultViewer />
    </Box>
  );
};
